import {UserDataService} from './user-data.service';
import {catchError, tap} from 'rxjs/operators';
import {of} from 'rxjs';

export function initializeApp(dataService: UserDataService): any {
  return () =>
    dataService
      .fetchData()
      .pipe(catchError(error => {
        return of(null);
      }), tap(data => {
        return dataService.setData(data);
      }))
      .toPromise();
}
